import React from 'react';
import { useSelector } from 'react-redux';

import ResponseItem from './ResponseItem';

import scss from '../AiPlayground.module.scss';

function ResponsesList() {
  const responses = useSelector((state) => state.aiPlayground.responses);

  return (
    <ul className={scss.responsesList}>
      {responses.map((response, index) => (
        <ResponseItem key={`${response.message}-${index}`} response={response} />
      ))}
    </ul>
  );
}

export default ResponsesList;
